<div>
    <p-toolbar>
        <!-- <p-message severity="info" text="Placeholder"></p-message> -->
    </p-toolbar>
    <p-table stripedRows #SettingsTable [scrollable]="true" [style]="{ 'max-width': '100%' }" scrollHeight="60vh"
        [value]="settings" dataKey="id" [virtualRowHeight]="10" [virtualScroll]="true">

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="17" style="text-align: center">
                    <div class="tabulator-placeholder">
                        <span> No Data Available </span>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template #header>
            <tr>
                <th style="width: 100%; text-align: center; justify-content: center;" class="colgroup" colspan="2">PERIOD PROCESS SETTINGS</th>
            </tr>
            <tr>
                <th class="edit-cell">
                    <i class="fa far fa-edit" title="Select"></i>
                </th>
                <th pSortableColumn="">
                    Setting
                    <p-sortIcon field="" ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order">
                    </p-sortIcon>
                </th>
            </tr>
            <!-- <tr>
                <th class="tabulator-header-filter select-cell"></th>
                <th class="tabulator-header-filter large-cell"></th>
            </tr> -->
        </ng-template>
        <ng-template #body let-setting>
            <tr data-id="row-{{ setting.id }}" [pSelectableRow]="setting">
                <td class="edit-cell" style="text-align: center; align-items: center">
                    <p-checkbox binary="true" [(ngModel)]="setting.SettingValue" (onChange)="onCheckboxChange($event, setting)"></p-checkbox>
                </td>
                <td>
                    {{ setting.SettingTypeLabel }}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
